import App from './App';
import Main from './Main/Main';
import Login from './SignUp_Login/Login';
import SignUp from './SignUp_Login/SignUp';
import ResetPassword from './SignUp_Login/ResetPassword';
import ForgotPassword from './SignUp_Login/ForgotPassword';
import EmailVerified from './EmailVerified';
import NotFound from './404';
import DeviceDetail from './DeviceDetail';
import CompanionSignUp from './SignUp_Login/CompanionSignUp';
import CanCareSignup from './CanCare/Signup/SignUp';
import CanCareMain from './CanCare/Main/Main';
import Chats from './CanCare/Chats/Chats';
import AddDevice from './CanCare/AddDevice/AddDevice';
import EditProfile from './CanCare/EditProfile/EditProfile';
import Medications from './CanCare/Medications/Medications';
import Caregivers from './CanCare/Caregivers/Caregivers';
import Calendar from './CanCare/Calendar/Calendar';
import CanVideos from './CanCare/CanVideos/CanVideos';
import CanEmergency from './CanCare/CanEmergency/CanEmergency';
import DeleteAccount from './DeleteAccount/DeleteAccount';
import CareRecipients from './CanCare/CareRecipients/CareRecipients';
import CareRecipientDetailScreen from './CanCare/CareRecipients/CareRecipientDetailScreen';
import SignUpOnboarding from './SignUp_Login/SignUpOnboarding';
import SignUpByInvite from './SignUp_Login/SignUpByInvite';
import HealthOverview from './CanCare/HealthOverview/HealthOverview';
import NutritionAnalysis from './CanCare/NutritionAnalysis/NutritionAnalysis';
import DoctorVisit from './CanCare/DoctorVisit/DoctorVisit';
const routes = [
  {
    path: '/',
    component: App,
    exact: true,
  },
  {
    path: '/main',
    // component: Main,
    component: CanCareMain,
    private: true,
  },
  {
    path: '/login',
    component: Login,
    private: false,
  },
  {
    path: '/sign-up',
    component: SignUp,
    private: false,
  },
  {
    path: '/forgot-password',
    component: ForgotPassword,
    private: false,
  },
  {
    path: '/reset-password',
    component: ResetPassword,
    private: false,
  },
  {
    path: '/email-verified',
    component: EmailVerified,
    private: false,
  },
  {
    path: '/Device-detail/:deviceId',
    component: DeviceDetail,
    private: true,
  },
  {
    path: '/companion-sign-up',
    component: CompanionSignUp,
    private: false,
  },
  {
    path: '/cancare-sign-up',
    component: CanCareSignup,
    private: false,
  },
  {
    path: '/chats',
    component: Chats,
    private: true,
  },
  // {
  //   path: '/add-device',
  //   component: AddDevice,
  // },
  {
    path: '/edit-profile',
    component: EditProfile,
    private: true,
  },
  {
    path: '/health-overview',
    component: HealthOverview,
    private: true,
  },
  {
    path: '/medications',
    component: Medications,
    private: true,
  },
  {
    path: '/caregivers',
    component: Caregivers,
    private: true,
  },
  {
    path: '/calendar',
    component: Calendar,
    private: true,
  },
  {
    path: '/can-videos',
    component: CanVideos,
    private: true,
  },
  {
    path: '/can-emergency',
    component: CanEmergency,
    private: true,
  },
  {
    path: '/delete-account',
    component: DeleteAccount,
    private: true,
  },
  {
    path: '/care-recipients',
    component: CareRecipients,
    exact: true,
    private: true,
  },
  {
    path: '/care-recipients/:userId/recipient-details',
    component: CareRecipientDetailScreen,
    exact: true,
    private: true,
  },
  {
    path: '/sign-up-onboarding',
    component: SignUpOnboarding,
    private: false,
  },
  {
    path: '/sign-up-by-invite',
    component: SignUpByInvite,
    private: false,
  },
  {
    path: '/nutrition-analysis',
    component: NutritionAnalysis,
    private: true,
  },
  {
    path: '/doctor-visit',
    component: DoctorVisit,
    private: true,
  },
  {
    path: '*',
    component: NotFound,
    private: false,
  },
];

export default routes;
